<div class="row">
    <div class="col-auto">
        <ul class="mb-0">
            <li class="">
                <span class="badge badge-secondary">{{companyInfo.companyNm}}</span>
                소속 차량을 관리
            </li>
            <li class="">
                공급 승인
                <ul class="mb-0">
                    <li class="">
                        공급 대상 회사에 차량 정보 표시 승인 여부
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
<div class="row mt-3">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        그룹
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgTeamId"
                (ngModelChange)="changeTeamInfo($event)">
                <option [ngValue]="''" *ngIf="userGroupId <= 100">전체그룹</option>
                <option [ngValue]="'undefined'">미설정</option>
                <option *ngFor="let item of listTeam;"
                    [ngValue]="item.dtgTeamId">
                    {{item.dtgTeamNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        차량종류
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgCarType"
                (ngModelChange)="changeCarType($event)">
                <option *ngFor="let item of listCarType;"
                    [ngValue]="item.dtgCarType">
                    {{item.dtgCarTypeNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        사용여부
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="useYn"
                (ngModelChange)="changeUseYn($event)">
                <option [ngValue]="''">전체</option>
                <option [ngValue]="'Y'">Y</option>
                <option [ngValue]="'N'">N</option>
            </select>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0 text-nowrap">
        <thead class="">
            <th>
                회사이름
            </th>
            <th>
                그룹이름
            </th>
            <th>
                차량종류
            </th>
            <th>
                단말번호
            </th>
            <th>
                차량번호
            </th>
            <th>
                운전자ID
            </th>
            <th>
                운전자이름
            </th>
            <th>
                사용여부
            </th>
            <th>
                서비스 시작
            </th>
            <th>
                E-Tas자동
            </th>
            <th>
                마지막 수신
            </th>
            <th [hidden]="listType === DtgListType.modal">
                편집
            </th>
        </thead>
        <tbody class="">
            <ng-container *ngFor="let item of listCar;">
                <tr>
                    <td>
                        {{item.companyNm}}
                    </td>
                    <td>
                        <span [hidden]="!item.dtgTeamNm">{{item.dtgTeamNm}}</span>
                        <span [hidden]="item.dtgTeamNm" class="text-warning">
                            미설정
                        </span>
                    </td>
                    <td class="small">
                        {{item.dtgCarTypeNm}}
                    </td>
                    <td>
                        <span [hidden]="listType === DtgListType.modal">{{item.dtgUnitId}}</span>
                        <button type="button" class="btn btn-sm btn-link px-0"
                            [hidden]="listType === DtgListType.list"
                            (click)="clickSelectCar(item)">
                            <span class="">{{item.dtgUnitId}}</span>
                        </button>
                    </td>
                    <td>
                        <span [hidden]="!item.dtgCarNo">{{item.dtgCarNo}}</span>
                        <span [hidden]="item.dtgCarNo" class="text-warning">
                            미설정
                        </span>
                    </td>
                    <td>
                        <span [hidden]="!item.userId">{{item.userId}}</span>
                        <span [hidden]="item.userId" class="text-warning">
                            미설정
                        </span>
                    </td>
                    <td>
                        <span [hidden]="!item.userNm">{{item.userNm}}</span>
                        <span [hidden]="item.userNm" class="text-warning">
                            미설정
                        </span>
                    </td>
                    <td class="text-center">
                        {{item.useYn}}
                    </td>
                    <td class="small">
                        {{item.serviceDtFrom}}
                    </td>
                    <td class="text-center">
                        {{item.etasUseYn}}
                    </td>
                    <td class="small">
                        {{item.updateDt}}
                    </td>
                    <td [hidden]="listType === DtgListType.modal">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="clickOpenModalCarInfo(DtgActionType.update,item)">
                            <i class="mdi mdi-pen"></i>
                            <span class="ml-1">수정</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
                            (click)="clickOpenModalFormEtasCar(DtgActionType.update,item)">
                            <i class="mdi mdi-pen"></i>
                            <span class="ml-1">E-Tas설정</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary ml-2"
                            [routerLink]="['/','dtg','manage','car','ext','accept','main',item.dtgUnitId]">
                            <i class="mdi mdi-pen"></i>
                            <span class="ml-1">공급승인관리</span>
                        </button>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>